var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "dialog-screen" }, [
    _c("div", { staticClass: "form-info", staticStyle: { padding: "0px" } }, [
      _c("div", { staticClass: "form-row" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value", staticStyle: { width: "300px" } },
          [
            _c("el-input", {
              attrs: { placeholder: "请输入", title: "配货标题" },
              model: {
                value: _vm.title,
                callback: function($$v) {
                  _vm.title = $$v
                },
                expression: "title"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _vm._m(1),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value", staticStyle: { width: "300px" } },
          [
            _c("el-input", {
              attrs: { placeholder: "请输入", title: "税率(%)" },
              on: {
                change: function($event) {
                  _vm.taxRateChange(_vm.taxRate)
                }
              },
              model: {
                value: _vm.taxRate,
                callback: function($$v) {
                  _vm.taxRate = $$v
                },
                expression: "taxRate"
              }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "form-value" },
          [
            _c(
              "el-checkbox",
              {
                staticClass: "ml15",
                model: {
                  value: _vm.autoSend,
                  callback: function($$v) {
                    _vm.autoSend = $$v
                  },
                  expression: "autoSend"
                }
              },
              [_vm._v("发送")]
            )
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "table-layout" },
      [
        _c(
          "el-table",
          {
            ref: "allocFormImpTable",
            staticClass: "thin",
            staticStyle: { width: "100%", "font-size": "12px" },
            attrs: {
              data: _vm.pageAllocFormImpList,
              height: _vm.tableHeight,
              border: "",
              "row-class-name": _vm.markSelectedRowClassName
            },
            on: { "selection-change": _vm.handleSelectionChange }
          },
          [
            _c("el-table-column", {
              attrs: {
                type: "selection",
                width: "40",
                align: "center",
                fixed: "left"
              }
            }),
            _vm._v(" "),
            _c(
              "el-table-column",
              {
                attrs: {
                  label: "源件",
                  width: "60",
                  align: "center",
                  fixed: "left"
                }
              },
              [
                _c("el-table-column", {
                  attrs: {
                    prop: "rowNo",
                    label: "行号",
                    width: "60",
                    align: "center"
                  }
                })
              ],
              1
            ),
            _vm._v(" "),
            _c("el-table-column", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.startFlag,
                  expression: "startFlag"
                }
              ],
              attrs: {
                prop: "failed",
                label: "执行状态",
                width: "60",
                align: "center",
                fixed: "left"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.failed != null
                        ? _c("div", [
                            rows.row.failed
                              ? _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "red",
                                      "font-size": "20px"
                                    }
                                  },
                                  [_vm._v("×")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticStyle: {
                                      color: "green",
                                      "font-size": "20px"
                                    }
                                  },
                                  [_vm._v("√")]
                                )
                          ])
                        : _c("span", { staticClass: "font-gray3" }, [
                            _vm._v("未执行")
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.startFlag,
                  expression: "startFlag"
                }
              ],
              attrs: {
                prop: "failDesc",
                label: "失败描述",
                width: "300",
                align: "left",
                fixed: "left"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "机构名称", prop: "buyerShopName", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.buyerShopName.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title:
                                  rows.row.validateInfo.buyerShopName.errorMsg
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.buyerShopName) + " ")
                              ])
                            ]
                          )
                        : _c("div", [_vm._v(_vm._s(rows.row.buyerShopName))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "地址信息",
                prop: "buyerRecvRegionName",
                width: "200"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.buyerRecvRegionName.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title:
                                  rows.row.validateInfo.buyerRecvRegionName
                                    .errorMsg
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(
                                  _vm._s(rows.row.buyerRecvRegionName) + " "
                                )
                              ])
                            ]
                          )
                        : _c("div", [
                            _vm._v(_vm._s(rows.row.buyerRecvRegionName))
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "详细地址",
                prop: "buyerRecvStreet",
                width: "350"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.buyerRecvStreet.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title:
                                  rows.row.validateInfo.buyerRecvStreet.errorMsg
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.buyerRecvStreet))
                              ])
                            ]
                          )
                        : _c("span", [_vm._v(_vm._s(rows.row.buyerRecvStreet))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "联系人",
                prop: "buyerRecvContractName",
                width: "100"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.buyerRecvContractName.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title:
                                  rows.row.validateInfo.buyerRecvContractName
                                    .errorMsg
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.buyerRecvContractName))
                              ])
                            ]
                          )
                        : _c("span", [
                            _vm._v(_vm._s(rows.row.buyerRecvContractName))
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "联系电话",
                prop: "buyerRecvContactTel",
                align: "center",
                width: "100"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.buyerRecvContactTel.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title:
                                  rows.row.validateInfo.buyerRecvContactTel
                                    .errorMsg
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.buyerRecvContactTel))
                              ])
                            ]
                          )
                        : _c("span", [
                            _vm._v(_vm._s(rows.row.buyerRecvContactTel))
                          ])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "供应商", prop: "sellerName", width: "200" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.sellerName.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title: rows.row.validateInfo.sellerName.errorMsg
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.sellerName) + " ")
                              ])
                            ]
                          )
                        : _c("div", [_vm._v(_vm._s(rows.row.sellerName))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "商品名称", prop: "title", width: "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.title.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title: rows.row.validateInfo.title.errorMsg
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(rows.row.title) + " ")])]
                          )
                        : _c("div", [_vm._v(_vm._s(rows.row.title))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "分类", prop: "catName", width: "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.catName.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title: rows.row.validateInfo.catName.errorMsg
                              }
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(rows.row.catName) + " ")
                              ])
                            ]
                          )
                        : _c("div", [_vm._v(_vm._s(rows.row.catName))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "品牌", prop: "brandName", width: "150" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.brandName.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title: rows.row.validateInfo.brandName.errorMsg
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(rows.row.brandName))])]
                          )
                        : _c("span", [_vm._v(_vm._s(rows.row.brandName))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { width: "200", label: "关联定义" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.assetDefId != null
                        ? _c("div", { staticClass: "inline-block" }, [
                            _vm._v("已关联")
                          ])
                        : _c("div", { staticClass: "inline-block" }, [
                            _vm._v("未关联")
                          ]),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn-link fr inline-block",
                          on: {
                            click: function($event) {
                              _vm.delDevcDef(rows.row)
                            }
                          }
                        },
                        [_vm._v("清除")]
                      ),
                      _vm._v(" "),
                      _c(
                        "a",
                        {
                          staticClass: "swb-btn-link fr inline-block",
                          on: {
                            click: function($event) {
                              _vm.setDevcDef(rows.row)
                            }
                          }
                        },
                        [_vm._v("选择")]
                      ),
                      _vm._v(" "),
                      rows.row.assetDefId == null &&
                      (rows.row.asmblAccFlag ||
                        (!_vm.needAudit && !rows.row.asmblAccFlag))
                        ? _c(
                            "a",
                            {
                              staticClass: "swb-btn-link fr inline-block",
                              on: {
                                click: function($event) {
                                  _vm.saveDevcDef(rows.row)
                                }
                              }
                            },
                            [_vm._v("生成定义")]
                          )
                        : _vm._e()
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "left",
                width: "120px",
                prop: "devcName",
                label: "定义全名称"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "center",
                prop: "asmblAccFlag",
                label: "组装件",
                width: "130"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: rows.row.asmblAccFlag,
                            expression: "rows.row.asmblAccFlag"
                          }
                        ],
                        attrs: { type: "checkbox" },
                        domProps: {
                          checked: Array.isArray(rows.row.asmblAccFlag)
                            ? _vm._i(rows.row.asmblAccFlag, null) > -1
                            : rows.row.asmblAccFlag
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = rows.row.asmblAccFlag,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      rows.row,
                                      "asmblAccFlag",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      rows.row,
                                      "asmblAccFlag",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(rows.row, "asmblAccFlag", $$c)
                              }
                            },
                            function($event) {
                              _vm.commonChangeEvent(rows.row, true)
                            }
                          ]
                        }
                      })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "price",
                label: "含税价(元)",
                width: "90"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.price.validateOk
                        ? _c("el-input", {
                            staticStyle: {
                              "background-color": "#edd28b",
                              width: "95%"
                            },
                            attrs: {
                              type: "number",
                              size: "4",
                              min: 0,
                              title: rows.row.validateInfo.price.errorMsg
                            },
                            on: {
                              change: function($event) {
                                _vm.commonChangeEvent(rows.row)
                              }
                            },
                            model: {
                              value: rows.row.price,
                              callback: function($$v) {
                                _vm.$set(rows.row, "price", _vm._n($$v))
                              },
                              expression: "rows.row.price"
                            }
                          })
                        : _c("el-input", {
                            staticStyle: { width: "95%" },
                            attrs: { type: "number", size: "4", min: 0 },
                            on: {
                              change: function($event) {
                                _vm.priceChangeEvent(rows.row)
                              }
                            },
                            model: {
                              value: rows.row.price,
                              callback: function($$v) {
                                _vm.$set(rows.row, "price", _vm._n($$v))
                              },
                              expression: "rows.row.price"
                            }
                          })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "taxRate",
                label: "税率(%)",
                width: "90"
              }
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                align: "right",
                prop: "ntxPrice",
                label: "未税价(元)",
                width: "90"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      rows.row.ntxPrice != null
                        ? _c("span", [_vm._v(_vm._s(rows.row.ntxPrice))])
                        : _c("span", [_vm._v("0.00")])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "配货数量", prop: "quantity", width: "100" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.quantity.validateOk
                        ? _c("el-input", {
                            staticStyle: {
                              "background-color": "#edd28b",
                              width: "95%"
                            },
                            attrs: {
                              type: "number",
                              size: "4",
                              min: 0,
                              title: rows.row.validateInfo.quantity.errorMsg
                            },
                            on: {
                              change: function($event) {
                                _vm.commonChangeEvent(rows.row)
                              }
                            },
                            model: {
                              value: rows.row.quantity,
                              callback: function($$v) {
                                _vm.$set(rows.row, "quantity", _vm._n($$v))
                              },
                              expression: "rows.row.quantity"
                            }
                          })
                        : _c("el-input", {
                            staticStyle: { width: "95%" },
                            attrs: { type: "number", size: "4", min: 0 },
                            on: {
                              change: function($event) {
                                _vm.commonChangeEvent(rows.row)
                              }
                            },
                            model: {
                              value: rows.row.quantity,
                              callback: function($$v) {
                                _vm.$set(rows.row, "quantity", _vm._n($$v))
                              },
                              expression: "rows.row.quantity"
                            }
                          })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "单位", prop: "unit" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.unit.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title: rows.row.validateInfo.unit.errorMsg
                              }
                            },
                            [_c("span", [_vm._v(_vm._s(rows.row.unit))])]
                          )
                        : _c("span", [_vm._v(_vm._s(rows.row.unit))])
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: {
                label: "要求到货日期",
                prop: "desireArriveDate",
                align: "center",
                width: "120"
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.desireArriveDate.validateOk
                        ? _c(
                            "div",
                            {
                              staticStyle: {
                                "background-color": "#edd28b",
                                width: "100%",
                                height: "100%"
                              },
                              attrs: {
                                title:
                                  rows.row.validateInfo.desireArriveDate
                                    .errorMsg
                              }
                            },
                            [
                              _c("el-date-picker", {
                                attrs: {
                                  type: "date",
                                  placeholder: "选择日期",
                                  "picker-options": _vm.pickerOptions0,
                                  format: "yyyy-MM-dd"
                                },
                                model: {
                                  value: rows.row.desireArriveDate,
                                  callback: function($$v) {
                                    _vm.$set(rows.row, "desireArriveDate", $$v)
                                  },
                                  expression: "rows.row.desireArriveDate"
                                }
                              })
                            ],
                            1
                          )
                        : _c("el-date-picker", {
                            attrs: {
                              type: "date",
                              placeholder: "选择日期",
                              "picker-options": _vm.pickerOptions0,
                              format: "yyyy-MM-dd"
                            },
                            model: {
                              value: rows.row.desireArriveDate,
                              callback: function($$v) {
                                _vm.$set(rows.row, "desireArriveDate", $$v)
                              },
                              expression: "rows.row.desireArriveDate"
                            }
                          })
                    ]
                  }
                }
              ])
            }),
            _vm._v(" "),
            _c("el-table-column", {
              attrs: { label: "说明", prop: "desc", width: "160" },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function(rows) {
                    return [
                      !rows.row.validateInfo.desc.validateOk
                        ? _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: rows.row.desc,
                                expression: "rows.row.desc"
                              }
                            ],
                            staticStyle: {
                              "background-color": "#edd28b",
                              width: "95%"
                            },
                            attrs: {
                              type: "text",
                              title: rows.row.validateInfo.desc.errorMsg
                            },
                            domProps: { value: rows.row.desc },
                            on: {
                              change: function($event) {
                                _vm.commonChangeEvent(rows.row)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(rows.row, "desc", $event.target.value)
                              }
                            }
                          })
                        : _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: rows.row.desc,
                                expression: "rows.row.desc"
                              }
                            ],
                            staticStyle: { width: "95%" },
                            attrs: { type: "text" },
                            domProps: { value: rows.row.desc },
                            on: {
                              change: function($event) {
                                _vm.commonChangeEvent(rows.row)
                              },
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.$set(rows.row, "desc", $event.target.value)
                              }
                            }
                          })
                    ]
                  }
                }
              ])
            })
          ],
          1
        )
      ],
      1
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "clearfix" },
      [
        _vm.totalCount > 0
          ? _c("el-pagination", {
              staticClass: "fl mt5",
              attrs: {
                background: "",
                "page-size": _vm.pageSize,
                "page-sizes": _vm.pageSizes,
                "current-page": _vm.pageNumber,
                total: _vm.totalCount,
                layout: "prev, pager, next, jumper, sizes, total"
              },
              on: {
                "current-change": _vm.handlePageChange,
                "size-change": _vm.handleSizeChange
              }
            })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swb-btn swb-btn-small fr mt10",
            on: { click: _vm.downloadAllocFormImpModel }
          },
          [_vm._v("导出全部配货信息")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swb-btn swb-btn-small fr mt10 mr10",
            on: { click: _vm.doAllocFormImpModelImport }
          },
          [_vm._v("检查并导入")]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "swb-btn swb-btn-small fr mt10 mr10",
            on: {
              click: function($event) {
                _vm.validateMerchtAllocFormImpModel(true)
              }
            }
          },
          [_vm._v("逐条检查")]
        )
      ],
      1
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "90px" } },
      [_c("label", { staticClass: "required" }, [_vm._v("配货标题:")])]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      { staticClass: "form-label", staticStyle: { width: "90px" } },
      [_c("label", { staticClass: "required" }, [_vm._v("税率(%):")])]
    )
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-5f1dfb16", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5f1dfb16","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/order/AllocFormImpCheck.vue
// module id = 2972
// module chunks = 0